// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"f8097718","453":"0facc132"}[chunkId] + ".chunk.js";
};